import { gql, useQuery } from '@apollo/client';

export const GET_LOCATION_BY_COMPANY_ID = gql`
  query getLocationsByCompanyId($companyId: ObjectId!) {
    getLocationsByCompanyId(companyId: $companyId) {
      _id
      name
      companyNumber
      datevNumberId
      datevNumber {
        _id
        datevNumber
      }
    }
  }
`;

export const useGetLocationsByCompanyId = (companyId?: string) => {
  const { data, loading } = useQuery(GET_LOCATION_BY_COMPANY_ID, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const locations = data?.getLocationsByCompanyId || [];

  return {
    locations: locations,
    loading,
  };
};
